/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';

import {Observable} from 'rxjs';


import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class EngineSqlService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * insert
     *
     * @param xDataStoreID X-DataStoreID
     * @param query query
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public insertUsingPOST(xDataStoreID: string, query: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public insertUsingPOST(xDataStoreID: string, query: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public insertUsingPOST(xDataStoreID: string, query: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public insertUsingPOST(xDataStoreID: string, query: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling insertUsingPOST.');
        }

        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling insertUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/sql/query-insert`,
            query,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
